import { j as l } from "./atoms-v218.js";
import { InputHelper as s } from "./atoms-v2702.js";
const m = ({
  children: e,
  colorTheme: t = "light",
  id: p,
  isError: r = !1,
  isGroupedInput: o = !1
}) => e ? /* @__PURE__ */ l.jsx(
  s,
  {
    $colorTheme: t,
    $isError: r,
    $isGroupedInput: o,
    id: p,
    ...r && { role: "alert" },
    children: e
  }
) : null;
export {
  m as InputHelper
};
